/**
 * Service-provider domain schemas, derived from the generated Zod (the retrieve
 * and list bases are structurally identical). See ./README.md.
 */
import { z } from 'zod';

import {
  ServiceProvidersListResponseItem,
  ServiceProvidersRetrieveResponse,
} from '~/data/generated/zod/service-providers/service-providers.zod';

// `.unwrap()` the generated `owner`: it is now `.nullable()` at source
// (AMP-633), and `.extend()` exists only on the inner object. Nullability is
// re-applied at each use site (`serviceProviderOwnerSchema.nullable()`).
const serviceProviderOwnerSchema = ServiceProvidersRetrieveResponse.shape.owner.unwrap().extend({
  email: z.string().optional(),
});

export const serviceProviderSchema = ServiceProvidersRetrieveResponse.extend({
  owner: serviceProviderOwnerSchema.nullable(),
});
export type ServiceProvider = z.infer<typeof serviceProviderSchema>;

export const serviceProviderListItemSchema = ServiceProvidersListResponseItem.extend({
  owner: serviceProviderOwnerSchema.nullable(),
});
export type ServiceProviderListItem = z.infer<typeof serviceProviderListItemSchema>;

export const serviceProviderListSchema = z.array(serviceProviderListItemSchema);
